export const MENU = {
  FILE_HOSTING: 'File Hosting',
};